// import { Directive, ElementRef, HostListener } from '@angular/core';
// import { NgControl } from '@angular/forms';

// @Directive({
//   selector: '[appRegistrationNumber]',
// })
// export class RegistrationNumberDirective {
//   constructor(private el: ElementRef) {}

//   @HostListener('input', ['$event']) onInput(event: Event): void {
//     const input = event.target as HTMLInputElement;
//     let value = input.value;
//     value = value.replace(/\s/g, '');
//     if (sessionStorage.getItem('registration_form_isValid') === 'false') {
//       // Remove existing hyphens
//       const sanitizedValue = value.replace(/-/g, '');

//       if (sanitizedValue.length < 7) {
//         const formattedValue = sanitizedValue.replace(/(.{2})/g, '$1-');
//         value = formattedValue.replace(/-$/, '');
//       } else {
//         // Add hyphen between consecutive numbers or letters after the 4th character
//         const prefix = sanitizedValue.substring(0, 2);
//         const prefix2 = sanitizedValue.substring(2, 4);
//         const postfix = sanitizedValue.substring(4);
//         const formattedPostfix = postfix.replace(/([A-Za-z]+|[0-9]+)/g, '$1-');
//         value = `${prefix}-${prefix2}-${formattedPostfix.replace(/-$/, '')}`;
//       }
//     }
//     // Update the input value
//     value = value.replace(/^-|-$/g, '');
//     // Remove any consecutive hyphens
//     value = value.replace(/--+/g, '-');
//     input.value = value;
//   }

//   @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent): void {
//     const clipboardData = event.clipboardData;
//     if (clipboardData) {
//       const pastedText = clipboardData.getData('text');
//       let formattedText = pastedText;

//       // formattedText = formattedText.slice(0, -4) + formattedText.slice(-3,-1);

//       const sanitizedValue = formattedText.replace(/-/g, '');

//       if (sanitizedValue.length < 7) {
//         const formattedValue = sanitizedValue.replace(/(.{2})/g, '$1-');
//         formattedText = formattedValue.replace(/-$/, '');
//       } else {
//         // Add hyphen between consecutive numbers or letters after the 4th character
//         const prefix = sanitizedValue.substring(0, 2);
//         const prefix2 = sanitizedValue.substring(2, 4);
//         const postfix = sanitizedValue.substring(4);
//         let formattedPostfix = postfix.replace(/([A-Za-z]+|[0-9]+)/g, '$1-');
//         formattedText = `${prefix}-${prefix2}-${formattedPostfix.replace(
//           /-$/,
//           ''
//         )}`;
//         let textWithoutSpaces = formattedText.trim();

//         let formattedValue = textWithoutSpaces[textWithoutSpaces.length - 1];

//         if (formattedValue == '-') {
//           textWithoutSpaces = textWithoutSpaces.slice(
//             0,
//             textWithoutSpaces.length - 1
//           );

//           formattedText = textWithoutSpaces;
//         }
//       }

//       document.execCommand('insertText', false, formattedText);
//       event.preventDefault();
//     }
//   }
// }
import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appRegistrationNumber]',
})
export class RegistrationNumberDirective {
  constructor(private el: ElementRef) {}

  // Prevent typing a dot or special characters directly
  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent): void {
    // Block dot
    if (event.key === '.') {
      event.preventDefault();
    }

    // Allow only letters, numbers, Backspace, Tab, Arrow keys, and Hyphen
    const allowedKeys = [
      'Backspace',
      'Tab',
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown',
      'Delete',
      'Shift',
      '-',
    ];
    const isAlphaNumeric = /^[a-zA-Z0-9]$/.test(event.key);

    if (!isAlphaNumeric && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event']) onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    // Remove spaces, dots, and special characters (only keep letters, numbers, hyphen)
    value = value.replace(/[^a-zA-Z0-9-]/g, '').replace(/\./g, '');

    if (sessionStorage.getItem('registration_form_isValid') === 'false') {
      const sanitizedValue = value.replace(/-/g, '');

      if (sanitizedValue.length < 7) {
        const formattedValue = sanitizedValue.replace(/(.{2})/g, '$1-');
        value = formattedValue.replace(/-$/, '');
      } else {
        const prefix = sanitizedValue.substring(0, 2);
        const prefix2 = sanitizedValue.substring(2, 4);
        const postfix = sanitizedValue.substring(4);
        const formattedPostfix = postfix.replace(/([A-Za-z]+|[0-9]+)/g, '$1-');
        value = `${prefix}-${prefix2}-${formattedPostfix.replace(/-$/, '')}`;
      }
    }

    // Final cleanup
    value = value.replace(/^-|-$/g, '').replace(/--+/g, '-');
    input.value = value;
  }

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent): void {
    const clipboardData = event.clipboardData;
    if (clipboardData) {
      let pastedText = clipboardData.getData('text');

      // Remove dots, hyphens, and special characters
      let sanitizedValue = pastedText.replace(/[^a-zA-Z0-9]/g, '');

      let formattedText = '';

      if (sanitizedValue.length < 7) {
        formattedText = sanitizedValue
          .replace(/(.{2})/g, '$1-')
          .replace(/-$/, '');
      } else {
        const prefix = sanitizedValue.substring(0, 2);
        const prefix2 = sanitizedValue.substring(2, 4);
        const postfix = sanitizedValue.substring(4);
        let formattedPostfix = postfix.replace(/([A-Za-z]+|[0-9]+)/g, '$1-');
        formattedText = `${prefix}-${prefix2}-${formattedPostfix.replace(
          /-$/,
          ''
        )}`;
      }

      document.execCommand('insertText', false, formattedText);
      event.preventDefault();
    }
  }
}
